import { default as _5_45month_45cart_45offerbOMNTm15VjMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/5-month-cart-offer.vue?macro=true";
import { default as _6_45month_45half_45priceru25Fsa5h7Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/6-month-half-price.vue?macro=true";
import { default as aboutQOb8jHAqqbMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/about.vue?macro=true";
import { default as billingkEHiXMcq5DMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/account/billing.vue?macro=true";
import { default as emptyservicesmO3zmY9iz5Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/account/emptyservices.vue?macro=true";
import { default as indexv77eb7nogxMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/account/index.vue?macro=true";
import { default as profile3GVJjsccS3Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/account/profile.vue?macro=true";
import { default as ServiceOfferseqTjlJDq1JMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/account/ServiceOffers.vue?macro=true";
import { default as accountPRVnMTO4dYMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/account.vue?macro=true";
import { default as authorizeCD0XFlzWRsMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/authorize.vue?macro=true";
import { default as bbc_45promo2mOqYKbfCSMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/bbc-promo.vue?macro=true";
import { default as broadband_45friends_45and_45family0Sx7PZpbFCMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/broadband-friends-and-family.vue?macro=true";
import { default as bundlesgx5VjHA93EMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/bundles.vue?macro=true";
import { default as chatFy19RqP83vMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/chat.vue?macro=true";
import { default as childfundYzQ4h7l82mMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/childfund.vue?macro=true";
import { default as compass_45embed2Vjx63tPddMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/compass-embed.vue?macro=true";
import { default as compassud1JDz3HO4Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/compass.vue?macro=true";
import { default as contactcoeXVRv9z9Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/contact.vue?macro=true";
import { default as coveragefoOIqtGZDGMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/coverage.vue?macro=true";
import { default as friends_45and_45family_45join_45nowUvLuFZldnoMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/friends-and-family-join-now.vue?macro=true";
import { default as glimpdsYyX4kiExMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/glimp.vue?macro=true";
import { default as hyperfibreMXBKnEx5ksMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/hyperfibre.vue?macro=true";
import { default as indexknxApO1ciJMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/index.vue?macro=true";
import { default as internet_45speed_45testFZwPGLBmrjMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/internet-speed-test.vue?macro=true";
import { default as join_45nowlMjjVhpneTMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/join-now.vue?macro=true";
import { default as loginYrN9fDtKPPMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/login.vue?macro=true";
import { default as logoutS2Js8G1ENnMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/logout.vue?macro=true";
import { default as mobile_45comparexkiM3XWBU6Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile-compare.vue?macro=true";
import { default as mobile_45friends_45and_45familygulwOZAfVkMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile-friends-and-family.vue?macro=true";
import { default as indexp48g87fC6yMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/index.vue?macro=true";
import { default as accountfcd8EzU1mVMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/account.vue?macro=true";
import { default as connection_45setup9p9dZC1FGtMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/connection-setup.vue?macro=true";
import { default as indexA443mC6ny2Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/index.vue?macro=true";
import { default as order_45summary4GiJdycepYMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/order-summary.vue?macro=true";
import { default as select_45plan8dpZuWU8ppMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/select-plan.vue?macro=true";
import { default as successTQw8sZXF5GMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/success.vue?macro=true";
import { default as registeryuKttSofzLMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register.vue?macro=true";
import { default as planseRBLFubbIgMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/plans.vue?macro=true";
import { default as privacytOf34KcWLrMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/privacy.vue?macro=true";
import { default as promotionsk03tYp6QX8Meta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/promotions.vue?macro=true";
import { default as refer_45a_45friendXbTIkw8gChMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/refer-a-friend.vue?macro=true";
import { default as _1tr2tKtWaPFMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/1.vue?macro=true";
import { default as _2O8J6vXZc5OMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/2.vue?macro=true";
import { default as _39MvfRlqiTPMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/3.vue?macro=true";
import { default as _4XTxCcqBpnZMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/4.vue?macro=true";
import { default as _5xOeepFaJZgMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/5.vue?macro=true";
import { default as index6S7pBwG6hRMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/index.vue?macro=true";
import { default as successa9jkVay4IPMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register/success.vue?macro=true";
import { default as registeriVKp3RatFAMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/register.vue?macro=true";
import { default as simply_45broadbandOw3UcEEZ5ZMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/simply-broadband.vue?macro=true";
import { default as sustainabilitywcOEyMBUcQMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/sustainability.vue?macro=true";
import { default as termsSVrKSISi1fMeta } from "/codebuild/output/src3551364499/src/zeronet-web/pages/terms.vue?macro=true";
export default [
  {
    name: "5-month-cart-offer",
    path: "/5-month-cart-offer",
    meta: _5_45month_45cart_45offerbOMNTm15VjMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/5-month-cart-offer.vue")
  },
  {
    name: "6-month-half-price",
    path: "/6-month-half-price",
    meta: _6_45month_45half_45priceru25Fsa5h7Meta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/6-month-half-price.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutQOb8jHAqqbMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/about.vue")
  },
  {
    name: accountPRVnMTO4dYMeta?.name,
    path: "/account",
    meta: accountPRVnMTO4dYMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/account.vue"),
    children: [
  {
    name: "account-billing",
    path: "billing",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/account/billing.vue")
  },
  {
    name: "account-emptyservices",
    path: "emptyservices",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/account/emptyservices.vue")
  },
  {
    name: "account",
    path: "",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/account/index.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/account/profile.vue")
  },
  {
    name: "account-ServiceOffers",
    path: "ServiceOffers",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/account/ServiceOffers.vue")
  }
]
  },
  {
    name: "authorize",
    path: "/authorize",
    meta: authorizeCD0XFlzWRsMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/authorize.vue")
  },
  {
    name: "bbc-promo",
    path: "/bbc-promo",
    meta: bbc_45promo2mOqYKbfCSMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/bbc-promo.vue")
  },
  {
    name: "broadband-friends-and-family",
    path: "/broadband-friends-and-family",
    meta: broadband_45friends_45and_45family0Sx7PZpbFCMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/broadband-friends-and-family.vue")
  },
  {
    name: "bundles",
    path: "/bundles",
    meta: bundlesgx5VjHA93EMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/bundles.vue")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/chat.vue")
  },
  {
    name: "childfund",
    path: "/childfund",
    meta: childfundYzQ4h7l82mMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/childfund.vue")
  },
  {
    name: "compass-embed",
    path: "/compass-embed",
    meta: compass_45embed2Vjx63tPddMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/compass-embed.vue")
  },
  {
    name: "compass",
    path: "/compass",
    meta: compassud1JDz3HO4Meta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/compass.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactcoeXVRv9z9Meta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/contact.vue")
  },
  {
    name: "coverage",
    path: "/coverage",
    meta: coveragefoOIqtGZDGMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/coverage.vue")
  },
  {
    name: "friends-and-family-join-now",
    path: "/friends-and-family-join-now",
    meta: friends_45and_45family_45join_45nowUvLuFZldnoMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/friends-and-family-join-now.vue")
  },
  {
    name: "glimp",
    path: "/glimp",
    meta: glimpdsYyX4kiExMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/glimp.vue")
  },
  {
    name: "hyperfibre",
    path: "/hyperfibre",
    meta: hyperfibreMXBKnEx5ksMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/hyperfibre.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexknxApO1ciJMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/index.vue")
  },
  {
    name: "internet-speed-test",
    path: "/internet-speed-test",
    meta: internet_45speed_45testFZwPGLBmrjMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/internet-speed-test.vue")
  },
  {
    name: "join-now",
    path: "/join-now",
    meta: join_45nowlMjjVhpneTMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/join-now.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginYrN9fDtKPPMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutS2Js8G1ENnMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/logout.vue")
  },
  {
    name: "mobile-compare",
    path: "/mobile-compare",
    meta: mobile_45comparexkiM3XWBU6Meta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile-compare.vue")
  },
  {
    name: "mobile-friends-and-family",
    path: "/mobile-friends-and-family",
    meta: mobile_45friends_45and_45familygulwOZAfVkMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile-friends-and-family.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    meta: indexp48g87fC6yMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/index.vue")
  },
  {
    name: registeryuKttSofzLMeta?.name,
    path: "/mobile/register",
    meta: registeryuKttSofzLMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register.vue"),
    children: [
  {
    name: "mobile-register-account",
    path: "account",
    meta: accountfcd8EzU1mVMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/account.vue")
  },
  {
    name: "mobile-register-connection-setup",
    path: "connection-setup",
    meta: connection_45setup9p9dZC1FGtMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/connection-setup.vue")
  },
  {
    name: "mobile-register",
    path: "",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/index.vue")
  },
  {
    name: "mobile-register-order-summary",
    path: "order-summary",
    meta: order_45summary4GiJdycepYMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/order-summary.vue")
  },
  {
    name: "mobile-register-select-plan",
    path: "select-plan",
    meta: select_45plan8dpZuWU8ppMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/select-plan.vue")
  },
  {
    name: "mobile-register-success",
    path: "success",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/mobile/register/success.vue")
  }
]
  },
  {
    name: "plans",
    path: "/plans",
    meta: planseRBLFubbIgMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/plans.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacytOf34KcWLrMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/privacy.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    meta: promotionsk03tYp6QX8Meta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/promotions.vue")
  },
  {
    name: "refer-a-friend",
    path: "/refer-a-friend",
    meta: refer_45a_45friendXbTIkw8gChMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/refer-a-friend.vue")
  },
  {
    name: registeriVKp3RatFAMeta?.name,
    path: "/register",
    meta: registeriVKp3RatFAMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register.vue"),
    children: [
  {
    name: "register-1",
    path: "1",
    meta: _1tr2tKtWaPFMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/1.vue")
  },
  {
    name: "register-2",
    path: "2",
    meta: _2O8J6vXZc5OMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/2.vue")
  },
  {
    name: "register-3",
    path: "3",
    meta: _39MvfRlqiTPMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/3.vue")
  },
  {
    name: "register-4",
    path: "4",
    meta: _4XTxCcqBpnZMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/4.vue")
  },
  {
    name: "register-5",
    path: "5",
    meta: _5xOeepFaJZgMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/5.vue")
  },
  {
    name: "register",
    path: "",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/index.vue")
  },
  {
    name: "register-success",
    path: "success",
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/register/success.vue")
  }
]
  },
  {
    name: "simply-broadband",
    path: "/simply-broadband",
    meta: simply_45broadbandOw3UcEEZ5ZMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/simply-broadband.vue")
  },
  {
    name: "sustainability",
    path: "/sustainability",
    meta: sustainabilitywcOEyMBUcQMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/sustainability.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsSVrKSISi1fMeta || {},
    component: () => import("/codebuild/output/src3551364499/src/zeronet-web/pages/terms.vue")
  }
]